<template>
    <section class="relative">
        <div class="absolute inset-0">
            <nuxt-img :width="backgroundImageWidth" :height="backgroundImageHeight" format="webp" :src="backgroundImageSrc"
                sizes="xs:330px sm:440px md:768px lg:1024px xl:1600px" alt="background"
                class="object-cover w-full h-full" loading="lazy" />
        </div>

        <div class="relative z-10 grid grid-cols-12 py-10 lg:py-20 gap-x-8">
            <div class="items-center md:col-span-7 col-span-12 px-4 bg 2xl:ml-[calc((100vw_-_1280px)_/_2)] grid">
                <div class="lg:py-10">
                    <h3 class="mb-4 text-center text-white uppercase md:text-left font-ww-light h1 lg:text-5xl" v-html="titleText"></h3>
                    <div class="grid items-center mt-5 lg:mt-10 gap-y-4 lg:pl-10">
                        <div class="flex items-start gap-3" v-for="(item, index) in items" :key="index">
                           <div class="pt-1 basis-6">
                            <nuxt-img :width="item.iconWidth" :height="item.iconHeight" format="webp" :src="item.icon" alt=""
                            class="" loading="lazy" />
                           </div>
                            <div class="text-white textp basis-full" v-html="item.text"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>

const props = defineProps({
    backgroundImageSrc: {
        type: String,
        default: '/assets/images/bg-cookie.png'
    },
    backgroundImageWidth: {
        type: Number,
        default: 1600
    },
    backgroundImageHeight: {
        type: Number,
        default: 351
    },
    titleText: {
        type: String,
        default: "Real frosted sugar cookie Coffee Natural Extracts"
    },
    items: {
        type: Array,
        default: () => [
            {
                icon: '/assets/images/check111.png',
                text: 'Derived Only From Their Natural Sources And Ingredients.',
                iconWidth: 22,
                iconHeight: 22
            },
            {
                icon: '/assets/images/check111.png',
                text: 'Zero Added Sugar.',
                iconWidth: 22,
                iconHeight: 22
            },
            {
                icon: '/assets/images/check111.png',
                text: 'Zero Added Calories.',
                iconWidth: 22,
                iconHeight: 22
            },
            {
                icon: '/assets/images/check111.png',
                text: 'We Use Only The Highest Quality Essential Oil Extracts.',
                iconWidth: 22,
                iconHeight: 22
            },
            {
                icon: '/assets/images/check111.png',
                text: 'Natural Oil Based Extracts Versus Artificial/Chemical Extracts',
                iconWidth: 22,
                iconHeight: 22
            }
        ]
    }
});

defineBuilderComponent({
    friendlyName: 'Background Image With Check List',
    inputs: [
        {
            name: 'backgroundImageSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png'],
            defaultValue: '/assets/images/bg-cookie.png'
        },
        {
            name: 'backgroundImageWidth',
            type: 'number',
            defaultValue: 1600
        },
        {
            name: 'backgroundImageHeight',
            type: 'number',
            defaultValue: 351
        },
        {
            name: 'titleText',
            type: 'richText',
            defaultValue: 'Real frosted sugar cookie Coffee Natural Extracts'
        },
        {
            name: 'items',
            type: 'list',
            defaultValue: [
                {
                    icon: '/assets/images/check111.png',
                    text: 'Derived Only From Their Natural Sources And Ingredients.',
                    iconWidth: 22,
                    iconHeight: 22
                },
                {
                    icon: '/assets/images/check111.png',
                    text: 'Zero Added Sugar.',
                    iconWidth: 22,
                    iconHeight: 22
                },
                {
                    icon: '/assets/images/check111.png',
                    text: 'Zero Added Calories.',
                    iconWidth: 22,
                    iconHeight: 22
                },
                {
                    icon: '/assets/images/check111.png',
                    text: 'We Use Only The Highest Quality Essential Oil Extracts.',
                    iconWidth: 22,
                    iconHeight: 22
                },
                {
                    icon: '/assets/images/check111.png',
                    text: 'Natural Oil Based Extracts Versus Artificial/Chemical Extracts',
                    iconWidth: 22,
                    iconHeight: 22
                }
            ],
            subFields: [
                {
                    name: 'icon',
                    type: 'file',
                    allowedFileTypes: [
                        'jpeg',
                        'jpg',
                        'png',
                        'svg'
                    ],
                    defaultValue: '/assets/images/check111.png'
                },
                {
                    name: 'text',
                    type: 'richText',
                    defaultValue: 'Derived Only From Their Natural Sources And Ingredients.'
                },
                {
                    name: 'iconWidth',
                    type: 'number',
                    defaultValue: 22
                },
                {
                    name: 'iconHeight',
                    type: 'number',
                    defaultValue: 22
                }
            ]
        }
    ]
});
</script>
